export default defineNuxtRouteMiddleware((to) => {
  const { loggedIn } = useUserSession();
  const config = useRuntimeConfig();

  // Verifica se o usuário está não autenticado
  if (loggedIn.value) {
    const baseUrl = config.public.baseUrl || ''; // Obtém a base URL do runtime config
    const callbackUrl = `${baseUrl}${to.fullPath || '/'}`; // Concatena a base URL com o caminho completo

    if (to.path !== '/home') {
      // Evita redirecionar para a mesma rota repetidamente
      return navigateTo(`/home?callbackUrl=${encodeURIComponent(callbackUrl)}`);
    }
  }

  return;
});
